module.exports = __webpack_public_path__ + "img/LI107376.d1d707db.png";